import React, { forwardRef } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

import type { FieldBaseProps } from './field.types';
import { useFieldIds } from './useFieldIds';
import { describedBy } from './FieldShell';

export interface CheckboxInputProps extends Omit<FieldBaseProps, 'hideLabel'> {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
  indeterminate?: boolean;
  name?: string;
  value?: string;
}

export const CheckboxInput = forwardRef<HTMLDivElement, CheckboxInputProps>(function CheckboxInput(
  { id: idProp, label, helperText, error, required, disabled, size = 'small', fullWidth = true, className, sx, checked, defaultChecked, onChange, indeterminate, name, value },
  ref,
) {
  const ids = useFieldIds(idProp);
  return (
    <FormControl ref={ref} error={error} disabled={disabled} required={required} fullWidth={fullWidth} className={className} sx={sx}>
      <FormControlLabel
        label={label}
        control={
          <Checkbox
            id={ids.id}
            size={size}
            checked={checked}
            defaultChecked={defaultChecked}
            indeterminate={indeterminate}
            name={name}
            value={value}
            onChange={(event, next) => onChange?.(next, event)}
            inputProps={{ 'aria-describedby': describedBy(ids, helperText) }}
          />
        }
      />
      {helperText !== undefined && helperText !== null && helperText !== '' && (
        <FormHelperText id={ids.helperId} sx={{ mx: 0 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
});
